import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=30e278bc&"
import script from "./Detail.vue?vue&type=script&lang=js&"
export * from "./Detail.vue?vue&type=script&lang=js&"
import style0 from "./Detail.vue?vue&type=style&index=0&id=30e278bc&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jonas/Projects/Risolto/operator-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30e278bc')) {
      api.createRecord('30e278bc', component.options)
    } else {
      api.reload('30e278bc', component.options)
    }
    module.hot.accept("./Detail.vue?vue&type=template&id=30e278bc&", function () {
      api.rerender('30e278bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/_templates/Detail.vue"
export default component.exports